module.exports = __webpack_public_path__ + "static/media/abdd849d.jpg";